import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import { List, Map } from 'immutable';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { updateDealProductField } from '../store/deal.store';
import { handleFormChanged } from '@/store/allaround.store.js';
import {
  ButtonWithFuncBound,
  DateTimePicker2 as DateTimePicker,
} from '@/component/form/FormControls.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import { dateTimePickerFormat } from '@/util/util.jsx';
import { formatCurrency, formatNumberZeroIfNull } from './BaseElement';
import trash from '../../../../../style/trash.png';
class InterestValuesTabClass extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showModalDeleteInterest: false };
  }

  handleAddInterest = () => {
    this.props.updateDealProductField(
      this.props.data.push(
        new Map({ currency: 'USD' })
      ));
  }

  openModalDeleteInterest = (idx) => {
    this.setState({ showModalDeleteInterest: true, idx });
  }

  closeModalDeleteInterest= () => {
    this.setState({ showModalDeleteInterest: false, idx: null });
  }

  yesButtonDeleteInterest = () => {
    this.props.updateDealProductField(
      this.props.data.remove(this.state.idx)
    );
    this.closeModalDeleteInterest();
  }

  handleChangeInterest = (idx, field, value) => {
    this.props.updateDealProductField(
      this.props.data.set(idx, this.props.data.get(idx).set(field, value))
    );
  }

  valueFormatter = (value, row) => (<div className="interest-column-value">
    <div
      className="interest-currencyinput"
      key={row.currency}
    >
      <CurrencyInput
        name="dueAmountCurrency"
        defaultValue={row.currency}
        noRates
        disabled={this.props.disabled}
        onChange={(val) => {
          this.handleChangeInterest(row.idx, 'currency', val);
        }}
      />
    </div>
    <FancyInput
      className="form-control"
      style={{ textAlign: 'right' }}
      fraction={2}
      positive
      negative={false}
      thousand
      disabled={this.props.disabled}
      type="number"
      value={parseFloat(row.value || 0).toFixed(2)}
      onChange={(e, val) => {
        this.handleChangeInterest(row.idx, 'value', val);
      }}
    />
  </div>)

  dateFormatter = (date, row) => <div className="interest-date">
    <DateTimePicker
      component={DateTimePicker}
      time={false}
      format={dateTimePickerFormat}
      defaultValue={date ? new Date(date) : undefined}
      disabled={this.props.disabled}
      onChange={(e, val) => {
        this.props.handleFormChanged();
        this.handleChangeInterest(row.idx, 'date', val);
      }}
    />
  </div>

  deleteButton = (idx) => <div>
    <ButtonWithFuncBound
      id="deleteInterest"
      bsStyle="link"
      style={{ padding: '4px 5px 3px 5px' }}
      className="btn-link-no-underline-on-hover"
      boundFunc={this.openModalDeleteInterest}
      args={[idx]}
      disabled={this.props.disabled}
    >
      <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
    </ButtonWithFuncBound>
  </div>

  render() {
    let total = new Map();
    this.props.data.forEach(e => {
      total = total.set(e.get('currency'),
        total.get(e.get('currency'), 0) + e.get('value', 0));
    });
    return (<div>
      <Row>
        <Col xs={12} md={3}>
          <Row className="interest-tab">
            <div className="interest-tab-header">
              <Button
                bsStyle="primary"
                className="interest-button-add"
                disabled={this.props.disabled}
                onClick={this.handleAddInterest}
              >
              Add
              </Button>
              <b>Values for interest calculation</b>
            </div>

            <BootstrapTable
              data={this.props.data.map((e, idx) => e.set('idx', idx)).toJS()}
              striped
              bordered={false}
              hover
            >
              <TableHeaderColumn
                dataField="value"
                dataFormat={this.valueFormatter}
              >
              Value
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="date"
                width="160px"
                dataFormat={this.dateFormatter}
              >
              Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="idx"
                width="45px"
                isKey
                dataFormat={this.deleteButton}
              />
            </BootstrapTable>
            <Col xs={12} className="interest-total">
              <b>Total:</b>
              <div className="interest-total-value">
                {total.map((v, k) =>
                  <div>{`${formatCurrency(k)} ${formatNumberZeroIfNull(v, '0,0.[00]')}`}</div>)}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal
        bsSize="small"
        show={this.state.showModalDeleteInterest}
        onHide={this.closeModalDeleteInterest}
      >
        <Modal.Body>
          Are you sure you want to delete the interest?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.yesButtonDeleteInterest}>Yes</Button>
          <Button onClick={this.closeModalDeleteInterest}>No</Button>
        </Modal.Footer>
      </Modal>
    </div>);
  }
}

export default connect((state, props) => ({
  data: state.getIn(['data', 'deals', 'deal', 'products', props.productIdx,
    'valuesForInterestCalc'],
  new List()),
}), (dispatch, props) => ({
  updateDealProductField(value) {
    updateDealProductField(dispatch, 'purchase', props.productIdx, 'valuesForInterestCalc',
      value);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
}))(InterestValuesTabClass);
